import Vue from 'vue';
import VueResource from 'vue-resource';
import converterMoeda from '~js/converter-moeda';
import formatarData from '~js/formatar-data';
import converterObjetoFormData from '~js/converter-objeto-formdata';
import salvarArquivo from '~js/salvar-arquivo';

Vue.use(VueResource);

function normalizarParaVisualizar(inscricao) {
  inscricao.dataNascimento = formatarData.paraData(inscricao.dataNascimento);

  return inscricao;
}

export default {
  lista: (pagina = 1, filtros) => {
    const parametros = Object.assign({}, { pagina }, filtros);

    return Vue.http.get('/api/SolicitacaoDoacaoRealizadas', { params: parametros });
  },
  listaDeDoacoes: async function () {
    return await Vue.http.get('/api/SolicitacaoDoacaoRealizadas/doacoes').then(response => response.data);
  },
  listagemExcel: filtros => {
    return Vue.http.get('/api/SolicitacaoDoacaoRealizadas/Excel',
      {
        params: {
          idDoacao: filtros.idDoacao,
          mostrarInscricoes: filtros.mostrarInscricoes,
        },
        responseType: 'blob',
      })
      .then(response => {
        if (response.body === '') return '';

        return salvarArquivo(response);
      });
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-doacao-realizadas/servico.js